import React from 'react';
import { FormControl, FormLabel, Input, Text, Textarea } from '@chakra-ui/react';
import { bountyV2Colors, formInputStyle, formLabelStyle } from '../theme';
import { IntroFieldKey, IntroFormValues } from '../introFormUtils';

type Props = {
  values: IntroFormValues;
  errors: Partial<Record<IntroFieldKey, string>>;
  onChange: (key: IntroFieldKey, value: string) => void;
};

/** Chakra's default indicator is red.500; use the feature's required colour instead. */
const REQUIRED = <Text as="span" color={bountyV2Colors.required} ml="3px">*</Text>;

const IntroContactFormFields: React.FC<Props> = ({ values, errors, onChange }) => (
  <>
    <FormControl isRequired isInvalid={!!errors.name}>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Contact name</FormLabel>
      <Input {...formInputStyle} value={values.name} onChange={e => onChange('name', e.target.value)} placeholder="Jane Doe" />
      {errors.name && <Text fontSize="13px" color={bountyV2Colors.errorText} mt="4px">{errors.name}</Text>}
    </FormControl>
    <FormControl isRequired isInvalid={!!errors.role}>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Role / title</FormLabel>
      <Input {...formInputStyle} value={values.role} onChange={e => onChange('role', e.target.value)} placeholder="Head of Marketing" />
      {errors.role && <Text fontSize="13px" color={bountyV2Colors.errorText} mt="4px">{errors.role}</Text>}
    </FormControl>
    <FormControl isInvalid={!!errors.email}>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Email</FormLabel>
      <Input {...formInputStyle} type="email" value={values.email} onChange={e => onChange('email', e.target.value)} placeholder="jane@company.com" />
      {errors.email && <Text fontSize="13px" color={bountyV2Colors.errorText} mt="4px">{errors.email}</Text>}
    </FormControl>
    <FormControl>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Phone</FormLabel>
      <Input {...formInputStyle} type="tel" value={values.phone} onChange={e => onChange('phone', e.target.value)} placeholder="+1 555 000 1111" />
    </FormControl>
    <FormControl>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Instagram handle</FormLabel>
      <Input {...formInputStyle} value={values.instagramHandle} onChange={e => onChange('instagramHandle', e.target.value)} placeholder="@handle" />
    </FormControl>
    <FormControl>
      <FormLabel {...formLabelStyle} requiredIndicator={REQUIRED}>Anything we should know? <Text as="span" color="#66666A">(optional)</Text></FormLabel>
      <Textarea {...formInputStyle} h="96px" py="12px" resize="none" value={values.note} onChange={e => onChange('note', e.target.value)}
        placeholder="How you know them, best way to approach, timing..." />
    </FormControl>
  </>
);

export default IntroContactFormFields;
